import React from "react";

const Cancelled = () => {
  return (
    <div style={{ padding: "40px", textAlign: "center" }}>
      <h2>お申し込みがキャンセルされました</h2>
      <p>もう一度お申し込みを希望される場合は、申込ページから再度手続きをお願いします。</p>
    </div>
  );
};

export default Cancelled;